const emptyObject = {};

export const selectSearchState = (state) => state?.search ?? emptyObject;

/**
 * The query the API was actually given, as opposed to the one in the URL.
 * They can differ while a request is in flight.
 */
export const selectSearchRequestQuery = (state) =>
  selectSearchState(state).query ?? emptyObject;
